import { FC, PropsWithChildren } from 'react'
import { ToastElement } from './components'
import { ToastContext } from './context'
import { useToast, useToastProvider } from './hooks'
import { ToastPrimitive } from './primitives'
export * from './types'

const Provider: FC<PropsWithChildren> = ({ children }) => {
  const toastData = useToastProvider()
  return (
    <ToastContext.Provider value={toastData}>
      {children}
      <ToastPrimitive.Provider swipeDirection="right">
        {toastData.toasts.map((toast) => (
          <ToastElement instance={toast} key={toast.id}  />
        ))}
        <ToastPrimitive.Viewport />
      </ToastPrimitive.Provider>
    </ToastContext.Provider>
  )
}

export const Toast = { Provider, useToast }
